<template>
  <img
    :src="src"
    :class="{ 'loading-new-image': loadingNewImage }"
    @load="onload"
  />
</template>

<script>
export default {
  name: "ProgressiveImage",
  props: {
    filename: String,
    maxres: Number
  },
  data() {
    return {
      loaded: false,
      loadingNewImage: false,
      currentRes: 64,
      minimumRes: 64
    };
  },
  computed: {
    src() {
      return this.filename + "/full/" + this.currentRes + ",/0/default.jpg";
    }
  },
  methods: {
    onload() {
      this.loadingNewImage = false;
      if (this.currentRes < this.maxres) {
        this.currentRes *= 4;
      }

      if (this.currentRes > this.maxres) {
        this.currentRes = this.maxres;
      }
    }
  },
  watch: {
    filename: {
      handler() {
        this.loadingNewImage = true;
        this.currentRes = this.minimumRes;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
img.loading-new-image {
  filter: blur(5px);
}
</style>
